import { BasePortal, MainLoading } from '@ice-web-app/shared-ui';
import { Suspense, lazy } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import { routes, toRelativePath } from './routes';

// Lazy load pages
const SchoolStructure = lazy(() => import('../pages/SchoolStructure'));
const CurriculumManagement = lazy(() => import('../pages/CurriculumManagement'));
const PeopleManagement = lazy(() => import('../pages/PeopleManagement'));
const TimetableConfiguration = lazy(() => import('../pages/TimetableConfiguration'));
const ScheduleGeneration = lazy(() => import('../pages/ScheduleGeneration'));
const ConflictResolution = lazy(() => import('../pages/ConflictResolution'));
const ViewsDistribution = lazy(() => import('../pages/ViewsDistribution'));
const RulesConstraints = lazy(() => import('../pages/RulesConstraints'));

export function ZoneRoutes() {
  return (
    <Routes>
      {/* Redirect from base to default route */}
      <Route path={toRelativePath(routes.base)} element={<Navigate to={routes.schoolStructure} />} />

      {/* Main Routes with Portal Layout */}
      <Route
        element={
          <BasePortal 
            sidebar 
            microSystem 
            showUserRole 
            miniSidebar={true} 
            navbar={true} 
            sidebarHeader={true} 
          />
        }
      >
        {/* School Structure Module */}
        <Route
          path={toRelativePath(routes.schoolStructure)}
          element={
            <Suspense fallback={<MainLoading />}>
              <SchoolStructure />
            </Suspense>
          }
        />

        {/* Curriculum Management Module */}
        <Route
          path={toRelativePath(routes.curriculumManagement)}
          element={
            <Suspense fallback={<MainLoading />}>
              <CurriculumManagement />
            </Suspense>
          }
        />

        {/* People Management Module */}
        <Route
          path={toRelativePath(routes.peopleManagement)}
          element={
            <Suspense fallback={<MainLoading />}>
              <PeopleManagement />
            </Suspense>
          }
        />

        {/* Timetable Configuration Module */}
        <Route
          path={toRelativePath(routes.timetableConfiguration)}
          element={
            <Suspense fallback={<MainLoading />}>
              <TimetableConfiguration />
            </Suspense>
          }
        />

        {/* Schedule Generation Module */}
        <Route
          path={toRelativePath(routes.scheduleGeneration)}
          element={
            <Suspense fallback={<MainLoading />}>
              <ScheduleGeneration />
            </Suspense>
          }
        />

        {/* Conflict Resolution Module */}
        <Route
          path={toRelativePath(routes.conflictResolution)}
          element={
            <Suspense fallback={<MainLoading />}>
              <ConflictResolution />
            </Suspense>
          }
        />

        {/* Views & Distribution Module */}
        <Route
          path={toRelativePath(routes.viewsDistribution)}
          element={
            <Suspense fallback={<MainLoading />}>
              <ViewsDistribution />
            </Suspense>
          }
        />

        {/* Rules & Constraints Module */}
        <Route
          path={toRelativePath(routes.rulesConstraints)}
          element={
            <Suspense fallback={<MainLoading />}>
              <RulesConstraints />
            </Suspense>
          }
        />
      </Route>

      {/* Catch-all for unmatched routes */}
      <Route path="*" element={<Navigate to={routes.notFound} />} />
    </Routes>
  );
}
